module.exports = __webpack_public_path__ + "static/media/SC.5cc9e583.jpg";